import React from 'react';
import {
  CommonStatusStep,
  IAPIServiceConfigItem,
  IMyFavoriteItem,
} from '../../../../model/api-modules';

import './style.scss';
import { createServiceFavorites } from '../../lib';
import { useDispatch } from 'react-redux';

interface IProps {
  readonly favoriteTotal?: string;
  readonly favoriteList: ReadonlyArray<IMyFavoriteItem>;
  readonly serviceConfig: IAPIServiceConfigItem;
  readonly showTotal?: boolean;
}

export const FavoriteButton = (props: IProps) => {
  const commonDispatch = useDispatch<any>();

  const favoriteItem = props.favoriteList.find(
    (item) => item.ServiceID === props.serviceConfig.id
  );

  const onClick = async (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>
  ) => {
    event.stopPropagation();
    const newStatus =
      favoriteItem?.Status === CommonStatusStep.Resolve
        ? CommonStatusStep.Pending
        : CommonStatusStep.Resolve;
    await createServiceFavorites(
      commonDispatch,
      props.serviceConfig.id,
      newStatus
    );
  };

  const renderCollectedIcon = () => {
    return <div className="star on" onClick={onClick}></div>;
  };

  const renderNotFavoriteIcon = () => {
    return (
      <div className="star not-favorite" onClick={onClick}>
        {' '}
      </div>
    );
  };

  const renderTotal = () => {
    if (props.favoriteTotal && props.showTotal) {
      return <span className="total-number">{props.favoriteTotal}</span>;
    }
    return null;
  };

  return (
    <div className="favorite-button">
      {favoriteItem ? renderCollectedIcon() : renderNotFavoriteIcon()}
      {renderTotal()}
    </div>
  );
};
